import type { ScenarioGridRowKey } from '@makemydeal/dr-dash-store/types/scenarioGridTypes';

import { ReadOnlyValue } from '../ScenarioGrid.style';
import { ScenarioRow } from './ScenarioRow';

type ReadOnlyValueRowProps = {
    rowKey: ScenarioGridRowKey;
    label: string;
    value: string;
    labelTestId?: string;
    valueTestId?: string;
};

export const ReadOnlyValueRow = ({ rowKey, label, value, labelTestId, valueTestId }: ReadOnlyValueRowProps) => (
    <ScenarioRow rowKey={rowKey} label={labelTestId ? <span data-testid={labelTestId}>{label}</span> : label}>
        <ReadOnlyValue data-testid={valueTestId ?? `scenario-row-${rowKey}-value`}>{value}</ReadOnlyValue>
    </ScenarioRow>
);
